import ServiceBase from "@/services/Base";
import Employee  from "@/models/Employee";
import EmployeeContactInfo from "@/models/EmployeeContactInfo";
// import AlertTransactionDTO from '@/Models/DTO/AlertTransactionDTO';


export default abstract class EmployeeService {
    private static _target = "Employee";

    public static GetEmployeeContactInfo(employeeNumber: string, dob: string, captchaKey: string) {
        return ServiceBase.api.get(this._target + "/GetEmployeeContactInfo?employeeNumber=" + 
        employeeNumber + "&dob=" + dob + "&captchaKey=" + captchaKey);
    }

    public static ConfirmEmployeeContactInfo(payload: EmployeeContactInfo)
    {
        return ServiceBase.api.post(
            this._target + "/ConfirmEmployeeContactInfo", JSON.stringify(payload));
    }

    public static UpdateEmployeeContactInfo(payload: EmployeeContactInfo) {
        return ServiceBase.api.post(
            this._target + "/UpdateEmployeeContactInfo", JSON.stringify(payload));

    }

}
